var Label = require('./base');

module.exports = Label;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/lib/label/index.js
// module id = 381
// module chunks = 0 1 2